

import React, { useEffect, useState,useRef } from "react";
import {
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  Divider,
  Avatar,
  Stack,
  IconButton,
  TextField,
  TextareaAutosize,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import { Download, Assessment } from "@mui/icons-material";
import DonateCallToAction from "./DonateCallToAction";
import CommentSection from "./CommentSection";
import { useLocation } from "react-router";
import { Edit as EditIcon, Save as SaveIcon, Close as CloseIcon } from "@mui/icons-material";
import { ProjectUpdate } from "../../api/orgService";
import useApi from "../../api/useApi";
import { toast } from "react-toastify";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddArticleCard from "../Admin/Consumer/AddArticleCard";
import SkeletonList from "./SkeletonList";
import AddProjectStep from "./AddProjectStep";

const ProjectDetailAdmin = ({projectData, isLoading}) => {
  const location = useLocation()
  const fileInputRef = useRef(null);
  const [activeStep, setActiveStep] = useState(0);
  const [project,setProject] = useState({})
  const [titleEdit, setTitleEdit] = useState(false);
  const [tempTitle, setTempTitle] = useState(project?.name);
  const [tempStory, setTempStory] = useState(project?.story);
  const [projectImage, setProjectImage] = useState(project?.image);
  const [storyEdit, setStoryEdit] = useState(false);
  const [isEditing,setIsEdit]=useState(false)
  const [file_upload_state, setConstFileUpload]=useState(false)
  const [mainArticleImagePreview,setMainArticleImagePreview]=useState(null)

  // --- TIMELINE STEPS ---
  const steps = [
    {
      label: "Pipeline",
      description:
        "Project proposed and under review for initial funding and feasibility analysis.",
      date: "17 Apr 2021",
    },
    {
      label: "Approved",
      description:
        "Funding approved and project implementation framework initiated.",
      date: "03 Jul 2025",
    },
    {
      label: "Under Implementation",
      description:
        "Ongoing execution phase — installations, team coordination, local partnerships.",
      date: "Currently Active",
    },
    {
      label: "To Be Completed",
      description: "Final evaluation and reporting before project closure.",
      date: "Expected Q3 2026",
    },
  ];

  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState([
      {
        label: "Approved",
        description:
          "Funding approved and project implementation framework initiated.",
        date: "03 Jul 2025",
      },
    ]);
  
    const [stepFormData, setStepFormData] = useState({
      label: "",
      description: "",
      date: "",
    });
  
    const handleStepOpen = () => setOpen(true);
    const handleStepClose = () => setOpen(false);
  
    const handleStepInputChange = (e) => {
      setStepFormData({
        ...stepFormData,
        [e.target.name]: e.target.value,
      });
      // steps.push(stepFormData)
    };

    const handleStepSubmit = () => {
      if (!stepFormData.label || !stepFormData.description || !stepFormData.date) return;
      setNotes([...notes, stepFormData]);
      setStepFormData({ label: "", description: "", date: "" });
      handleStepClose();
    };
  

  useEffect(()=>{},[projectData,isLoading])

  useEffect(()=>{
    if(stepFormData.label || stepFormData.description || stepFormData.date){
      setProject((prev)=>({
        ...prev,
          metadata: {
            ...prev.metadata,
          steps:stepFormData
          }
        }))
    }
  },[stepFormData])

  useEffect(()=>{
      if (projectData) {
        // setProject({
        //   ...projectData,
        //   publisher_id: projectData?.publisher?.id,
        // });
        console.log(projectData)
        setProject(projectData)
        setTempTitle(projectData?.name)
        setTempStory(projectData?.story)
  
      }
},[projectData,location])


  // ---------------------------publish Logic --------------------------------

  const { request: updateProject, data:projectUpdateData, error:projectUpdateError} = useApi(ProjectUpdate);
  
  
    useEffect(()=>{
      if (projectUpdateData?.status===200) {
        // setProject(projectUpdateData?.data);
        toast.success(`${JSON.stringify(projectUpdateData?.data,null,2)}`,{position: "top-center"});
      }
    },[projectUpdateData])
  
    useEffect(()=>{
        if(projectUpdateError){
            toast.error(`${JSON.stringify(projectUpdateError?.response?.data,null,2)}`,{position: "top-center"});
      }
    },[projectUpdateError])

  // -------------------------end publish logic -------------------------------

const [isAdding, setIsAdding] = useState(false);
  const [newStep, setNewStep] = useState({ label: "", description: "", date: "" });

  const handleAddStep = () => {
    // setSteps([...steps, newStep]);
    setNewStep({ label: "", description: "", date: "" });
    setIsAdding(false);
  };

  

  // --- RELATED ARTICLES ---
  const relatedArticles = [
    {
      title: "Boosting Renewable Energy Access in Jamaica",
      img: "https://picsum.photos/300/200?random=10",
      url:"/articles/Boosting Renewable Energy Access in Jamaica"
    },
    {
      title: "Community Empowerment through Clean Water",
      img: "https://picsum.photos/300/200?random=12",
      url:"/articles/Community Empowerment through Clean Water"
    },
    {
      title: "How Small Islands Adapt to Climate Risks",
      img: "https://picsum.photos/300/200?random=13",
      url:"/articles/How Small Islands Adapt to Climate Risks"
    },
  ];

//   ---- Project statistics
  const stats = [
    { label: "Total Funding", value: "$2.4M", color: "primary" },
    { label: "Beneficiaries", value: "25,000+", color: "success" },
    { label: "Countries", value: "3", color: "secondary" },
    { label: "Progress", value: "68%", color: "info" },
  ];

   // --- PROJECT REPORTS ---
   const reports = [
    {
      title: "Q1 2025 Progress Report",
      date: "May 10, 2025",
      link: "#",
    },
    {
      title: "Annual Report 2024",
      date: "Dec 31, 2024",
      link: "#",
    },
  ];

  const handleEdit = () => {
    if(isEditing){
      setIsEdit(!isEditing)
      alert("📝 Edit mode deactivated");
    }else{
      setIsEdit(!isEditing)
      alert("📝 Edit mode activated (placeholder)");
    }
  };


  const handleViewOriginal = () => {
    alert("👁️ Viewing original version (placeholder)");
  };

  
  
  const handleFileChange = async (event) => {
      const file = event.target.files[0];
      if (file){
      const previewUrl = URL.createObjectURL(file);
      // setArticle((prev) => ({ ...prev, img: previewUrl }));
      setMainArticleImagePreview({file:file,previewUrl:previewUrl})
  
  
      const formData = new FormData();
      formData.append("image", file);
      setConstFileUpload(true)
      try{
        const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
          method: "POST",
          body: formData, // don't add headers here
        });
      // console.log(res)
      if(res?.status===201){
        let result = await res.json()
        console.log("Upload urls: ",result)
        setMainArticleImagePreview((prev) => ({ ...prev, previewUrl: result?.path }));
        setProject((prev)=>({
          ...prev,
          image: result?.path,
        }));
      // setMaterialUrl(event,event.target.value)
        // setUploadUrls(prev=>res?.data)
        setConstFileUpload(false)
      }else{
        console.log(res)
      }
      }catch(error){
        console.log(error)
      }
      }
    }

  const handlePublish = () => {
    // alert("👁️ Viewing original version (placeholder)");
    // console.log(article)
    // let dataToSend = article
    
    // const publisher_id = article?.publisher?.id
    // let img = mainArticleImagePreview?.previewUrl || "test_link"
    // delete dataToSend.publisher;
    // delete dataToSend.created_at;
    // delete dataToSend.updated_at;
    // dataToSend.img = img
    // console.log(dataToSend);
    updateProject(project?.id,project)

  }

  const handleSaveDraft = () => {
    try {
      localStorage.setItem("projectDraft", JSON.stringify(project));
      alert("✅ Draft saved successfully!");
    } catch (error) {
      // console.error("Error saving draft:", error);
      alert("⚠️ Failed to save draft.");
    }
  };

  const handleLoadDraft = () => {
    const saved = localStorage.getItem("projectDraft");
    if (saved) {
      setProject(JSON.parse(saved));
      alert("✅ Draft loaded successfully!");
    } else {
      alert("⚠️ No draft found in local storage.");
    }
  };

  const handleEditTitleClick = () => {
    setTitleEdit(true)
  };

  const handleSaveTitle = ()=>{
    setProject(prev => ({
      ...prev, // keep everything else in the article
       name: tempTitle ,// add the new title
    }));
    setTitleEdit(false)
  }

  const handleCancelTitle = ()=>{
    setTitleEdit(false)
  }


  const handleEditStoryClick = () => {
    setStoryEdit(true)
  };

  const handleSaveStory = ()=>{
    setProject(prev => ({
      ...prev, // keep everything else in the article
       story: tempStory ,// add the new title
    }));
    setStoryEdit(false)
  }

  const handleCancelStoryUpdate = ()=>{
    setStoryEdit(false)
  }

  if(isLoading){
    return (
      <SkeletonList/>
    )
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 4,
        p: { xs: 2, md: 6 },
        justifyContent: "space-between",
      }}
    >
      {/* LEFT SIDE — INTERACTIVE STEPPER */}
      <Box
        sx={{
          flex: { xs: "1", md: "0 0 23%" },
          borderRight: { md: "1px solid #eee" },
          pr: { md: 3 },
        }}
      >
        <DonateCallToAction />
        <Typography variant="h6" sx={{ mb: 2 }}>
          Project Timeline
        </Typography>
       
        <Stepper activeStep={activeStep} orientation="vertical">
          {
          project?.metadata?.steps?.length>0?(
          
          project?.metadata?.steps?.map((step, index) => (
            <Step key={step.label}>
              <StepLabel>
                <Typography fontWeight={600}>{step.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {step.date}
                </Typography>
              </StepLabel>
              <StepContent>
                <Typography sx={{ mb: 2 }}>{step.description}</Typography>
                <Box>
                  <Button
                    disabled={index === 0}
                    onClick={() => setActiveStep(index - 1)}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() =>
                      index === steps.length - 1
                        ? setActiveStep(0)
                        : setActiveStep(index + 1)
                    }
                  >
                    {index === steps.length - 1 ? "Reset" : "Next"}
                  </Button>
                </Box>
              </StepContent>
            </Step>
          ))):""}
        </Stepper>
        <Button
          variant="contained"
          color="primary"
          onClick={handleStepOpen}
          sx={{ mt: 2 }}
        >
          Add Project Note/Step
        </Button>
        
              {/* Dialog Form */}
              <Dialog open={open} onClose={handleStepClose}>
                <DialogTitle>Add Project Note</DialogTitle>
                <DialogContent>
                  <Stack spacing={2} mt={1}>
                    <TextField
                      label="Label"
                      name="label"
                      value={stepFormData.label}
                      onChange={handleStepInputChange}
                      fullWidth
                      size="small"
                    />
                    <TextField
                      label="Description"
                      name="description"
                      value={stepFormData.description}
                      onChange={handleStepInputChange}
                      fullWidth
                      multiline
                      rows={3}
                      size="small"
                    />
                    <TextField
                      label="Date"
                      name="date"
                      type="date"
                      value={stepFormData.date}
                      onChange={handleStepInputChange}
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Stack>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleStepClose}>Cancel</Button>
                  <Button onClick={handleStepSubmit} variant="contained" color="primary">
                    Add
                  </Button>
                </DialogActions>
              </Dialog>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        {/* <Typography variant="h5" fontWeight="bold">
          Project Steps
        </Typography> */}
        {/* <AddProjectStep upStreamHandler={handleAddStep} /> */}
      </Stack>
      </Box>

      {/* CENTER — PROJECT MAIN CONTENT */}
      <Box
        sx={{
          flex: { xs: "1", md: "1 0 50%" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box flex={3}>
        {/* Title */}
        {/* <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
          {project?.name || "Project Title Placeholder"}
        </Typography> */}

        {titleEdit===true?
          <Stack direction="row" alignItems="center" spacing={1} sx={{ width: "100%" }}>
          <TextField
            fullWidth
            size="small"
            value={tempTitle}
            onChange={(e) => setTempTitle(e.target.value)}
            variant="outlined"
            autoFocus
          />
          <IconButton onClick={handleSaveTitle} color="success">
            <SaveIcon />
          </IconButton>
          <IconButton onClick={handleCancelTitle} color="error">
            <CloseIcon />
          </IconButton>
        </Stack>
          
          :<Stack direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{ width: "100%" }}>
            {/* <Typography
            variant="h3"
            fontWeight={700}
            gutterBottom
            sx={{ 
              fontFamily: "Merriweather, serif",
              wordWrap: 'break-word',
              overflowWrap: "break-word",
              whiteSpace: "normal",
              overflow: "hidden",
            }}
          >
            {article?.title}
          </Typography> */}
          <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
          {project?.name || "Project Title Placeholder"}
        </Typography>
          {isEditing===true?
          (<IconButton onClick={handleEditTitleClick} color="primary">
          <EditIcon />
          </IconButton>):""}
          </Stack>
          }

        {/* Main Image */}
        {/* <Box
          component="img"
          src={project?.image}
          alt={project?.name}
          sx={{
            width: '100%',
            height: 'auto',
            borderRadius: 2,
            mb: 3,
            boxShadow: 2,
          }}
          
        /> */}

        {project?.image? (
                <Box
                component="img"
                src={project?.image}
                alt={project?.name}
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: 2,
                  mb: 3,
                  boxShadow: 2,
                }}
                
              />
              ) : (
                <Box
                  sx={{
                    border: "2px dashed #ccc",
                    borderRadius: 2,
                    height: { xs: 300, md: 400 },
                    width: { xs: 500, md: 600 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    my: 3,
                  }}
                > 
                {
                  mainArticleImagePreview?
                  <img
                    src={mainArticleImagePreview?.previewUrl || URL.createObjectURL(mainArticleImagePreview?.file)}
                    alt="preview"
                    style={{
                      width: "80%",
                      borderRadius: "8px",
                      marginBottom: "8px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
                      mb:1
                    }}
                  />
                  :""
                }
                  <UploadIcon sx={{ fontSize: 60, color: "#aaa" }} />
                  <Button
                    variant="outlined"
                    onClick={() => fileInputRef.current.click()}
                    sx={{ mt: 2 }}
                    loading={file_upload_state}                    
                  >
                  {project?.image?.length>0? "Change File" : "Upload File"}
                  </Button>
                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </Box>
         )}
        

        {/* Publisher Info */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Avatar 
            src={project?.publisherImg || "https://i.pravatar.cc/150?img=4"} 
            alt={project?.publisherName || "Publisher"} 
            sx={{ width: 56, height: 56, mr: 2 }}
          />
          <Box>
            <Typography variant="subtitle1" fontWeight={600}>
              {project?.publisherName || "John Doe"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Published on {project?.date || "October 9, 2025"}
            </Typography>
          </Box>
          <Stack       
            direction="row"
            spacing={1}
            justifyContent="center"
            alignItems="center"
            sx={{ ml: 2 }}
          >
            <Button variant="outlined" size="small" onClick={handleEdit}>
              Edit
            </Button>
            <Button variant="outlined" size="small" onClick={handleViewOriginal}>
              View Original
            </Button>
            <Button variant="contained" color="primary" size="small" onClick={handleSaveDraft}>
              Save Draft
            </Button>
            <Button variant="contained" color="secondary" size="small" onClick={handleLoadDraft}>
              Load Draft
            </Button>
            <Button variant="contained" color="success" size="small" onClick={handlePublish}>
              Publish
            </Button>
          </Stack>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Story */}
        {storyEdit?
          <Stack direction="row" alignItems="center" spacing={1} sx={{ width: "100%" }}>
          <TextareaAutosize
            // fullWidth
            style={{ width: '100%', fontSize: '1rem', padding: '8px' }}
            size="small"
            value={tempStory}
            onChange={(e) => setTempStory(e.target.value)}
            variant="outlined"
            autoFocus
            multiline
            minRows={20} // you can adjust the number of visible rows
          />
          <IconButton onClick={handleSaveStory} color="success">
            <SaveIcon />
          </IconButton>
          <IconButton onClick={handleCancelStoryUpdate} color="error">
            <CloseIcon />
          </IconButton>
        </Stack>:
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{ width: "100%" }}>
        <Typography variant="body1" color="text.primary" lineHeight={1.8}sx={{whiteSpace: 'pre-wrap',}}>
          {project?.story || `This project? focuses on creating meaningful community impact by
          leveraging technology and innovation. Our goal was to deliver sustainable
          change through collaboration, creativity, and measurable results.`}
        </Typography>
        {isEditing?<IconButton onClick={handleEditStoryClick} color="primary">
          <EditIcon />
          </IconButton>:""}
        </Stack>}

        <Divider sx={{ my: 3 }} />

        {/* 📊 PROJECT STATISTICS */}
        <Box>
        <Typography variant="h6" sx={{ mb: 2 }}>
            Project Statistics
        </Typography>

        <Box
            sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            justifyContent: "space-between",
            }}
        >
            {stats.map((item) => (
            <Card
                key={item.label}
                sx={{
                flex: "1 1 45%",
                p: 2,
                textAlign: "center",
                boxShadow: 2,
                }}
            >
                <Typography
                variant="h6"
                fontWeight={600}
                color={item.color + ".main"}
                >
                {item.value}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                {item.label}
                </Typography>
            </Card>
            ))}
            <Card
                sx={{
                flex: "1 1 45%",
                p: 2,
                textAlign: "center",
                boxShadow: 2,
                }}
            >
                <IconButton>
                  <AddCircleOutlineIcon/>
                </IconButton>
                <Typography variant="h5" color="text.secondary">
                Add statistic
                </Typography>
            </Card>
        </Box>
        </Box>

        {/* 📑 PROJECT REPORTS */}
        <Box sx={{ mt: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
            Project Reports
        </Typography>

        {reports.map((report) => (
            <Card
            key={report.title}
            sx={{
                p: 2,
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
            >
            <Box>
                <Typography variant="subtitle1" fontWeight={600}>
                {report.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                {report.date}
                </Typography>
            </Box>
            <Button
                variant="outlined"
                startIcon={<Download />}
                href={report.link}
            >
                Download
            </Button>
            </Card>
        ))}
        </Box>
        <CommentSection />

      </Box>     
      </Box>

      {/* RIGHT SIDE — RELATED ARTICLES */}
      <Box
        sx={{
          flex: { xs: "1", md: "0 0 15%" },
          borderLeft: { md: "1px solid #eee" },
          pl: { md: 3 },
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Related Articles
        </Typography>
        <AddArticleCard />
        {relatedArticles.map((article, i) => (
          <Card
            key={i}
            sx={{
              mb: 2,
              boxShadow: 2,
              borderRadius: 2,
              cursor: "pointer",
              transition: "transform 0.3s",
              "&:hover": { transform: "scale(1.03)" },
            }}
          >
            <CardActionArea component="a" href={article?.url}>
            <CardMedia
              component="img"
              height="150"
              image={article.img}
              alt={article.title}
            />
            <CardContent>
              <Typography variant="subtitle1" fontWeight={600}>
                {article.title}
              </Typography>
            </CardContent>
            </CardActionArea>
          </Card>
        ))}

      </Box>
    </Box>
  )
}

export default ProjectDetailAdmin